import { render, staticRenderFns } from "./BridgeList.vue?vue&type=template&id=137bf914&scoped=true&"
import script from "./BridgeList.vue?vue&type=script&lang=js&"
export * from "./BridgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bf914",
  null
  
)

export default component.exports